import { render } from "./IconLaunch.vue?vue&type=template&id=c901c812"
import script from "./IconLaunch.vue?vue&type=script&lang=js"
export * from "./IconLaunch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__